import { Box, Theme, Typography, useTheme } from '@mui/material';
import {
  GaugeContainer,
  GaugeValueArc,
  GaugeReferenceArc,
  useGaugeState,
  gaugeClasses,
  Gauge,
} from '@mui/x-charts/Gauge';
import { useEffect, useState } from 'react';


export interface GISTMIndicadorAderenciaProps {
  aderencia: number;
  errorVal?: number;
  warningVal?: number;
  width?: number;
  duration?: number;
}

export const GISTMIndicadorAderencia: React.FC<GISTMIndicadorAderenciaProps> = ({ aderencia, errorVal = 25, warningVal = 70, width = 200, duration = 3000 }) => {
  const theme = useTheme();

  const [animatedValue, setAnimatedValue] = useState(0);
  useEffect(() => {
    let start: number | null = null;
    const startValue = 0;
    const endValue = aderencia;
    const diff = endValue - startValue;

    const step = (timestamp: number) => {
      if (!start) start = timestamp;
      const t = Math.min((timestamp - start) / duration, 1);
      const progress = t * (2 - t);
      setAnimatedValue(startValue + diff * progress);

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  }, [aderencia, duration]);

  return <Box sx={{ flex: 1, display: "flex", flexDirection: "column", p: 0, m: 0, gap: 0, alignItems: "center" }}>
    <Gauge
      width={width}
      height={0.6 * width}
      startAngle={-110}
      endAngle={110}
      value={animatedValue}
      cornerRadius="50%"
      text={""}
      sx={(_) => ({
        [`& .${gaugeClasses.valueArc}`]: {
          fill: gaugeColor(theme, animatedValue, errorVal, warningVal),
        },
      })}
    >
      <GaugePointer />
    </Gauge>

    <Typography fontSize={24} fontWeight={"bold"}>
      {(animatedValue / 100).toSignificantDigits("percent")}
    </Typography>
  </Box>;
};

export const gaugeColor = (theme: Theme, value: number, errorVal = 25, warningVal = 75) => {
  if (value > errorVal && value <= warningVal) {
    return theme.palette.warning.main;
  } else if (value > warningVal) {
    return theme.palette.success.main;
  }
  return theme.palette.error.main;
};

function GaugePointer() {
  const { valueAngle, outerRadius, cx, cy } = useGaugeState();

  if (valueAngle === null) {
    // No value to display
    return null;
  }

  const target = {
    x: cx + outerRadius * Math.sin(valueAngle),
    y: cy - outerRadius * Math.cos(valueAngle),
  };
  return (
    <g>
      <circle cx={cx} cy={cy} r={5} fill="red" />
      <path
        d={`M ${cx} ${cy} L ${target.x} ${target.y}`}
        stroke="red"
        strokeWidth={3}
      />
    </g>
  );
}